import Vue from 'vue'
import Vuex from 'vuex'
import state from './state.js'
import * as mutations from './mutations'
import * as actions from './actions'
import user from './modules/user.js'
import captcha from './modules/captcha'
import subscribe from './modules/subscribe'
import download from './modules/download'
import verifyEmail from './modules/verifyEmail'
import commission from './modules/commission'
import header from './modules/header'
import topup from './modules/topup'
import paymentMethods from './modules/paymentMethods'

Vue.use(Vuex)

export default new Vuex.Store({
  state: state,
  modules: {
    user,
    captcha,
    subscribe,
    download,
    verifyEmail,
    commission,
    header,
    topup,
    paymentMethods
  },
  mutations,
  actions
})



// WEBPACK FOOTER //
// ./src/store/index.js